
import { DetectedLocation } from '../mappings/LocationMapping';
import { DetectedFacilities } from '../filters/FacilitiesFilter';
import { validateVacationData } from './SearchUtils';

export const verifyAndFilterResults = (
  data: any[],
  detectedLocation: DetectedLocation,
  priceConstraints: any,
  detectedFacilities: DetectedFacilities | null,
  query: string
) => {
  console.log(`📊 === FINAL HIERARCHICAL SEARCH RESULTS ===`);
  console.log(`Found ${data?.length || 0} results for "${query}"`);
  
  if (!data || data.length === 0) {
    console.log('❌ No results found');
    return validateVacationData([]);
  }

  console.log('🔍 === HIERARCHY VERIFICATION ===');
  const countries = [...new Set(data.map(v => v.country))];
  const regions = [...new Set(data.map(v => v.region))];
  const cities = [...new Set(data.map(v => v.city))];
  const prices = data.filter(v => v.price).map(v => v.price).sort((a, b) => a - b);
  
  console.log('Countries in results:', countries);
  console.log('Regions in results:', regions);
  console.log('Cities in results:', cities);
  console.log('Price range in results:', prices.length > 0 ? `€${prices[0]} - €${prices[prices.length - 1]}` : 'No prices');
  
  // Facilities verification
  if (detectedFacilities) {
    console.log('🏨 === FACILITIES VERIFICATION ===');
    const facilitiesCheck = data.filter(v => {
      const facilities = v.facilities?.toLowerCase() || '';
      const description = v.description?.toLowerCase() || '';
      const name = v.name?.toLowerCase() || '';
      
      if (detectedFacilities.allInclusive) {
        return facilities.includes('all inclusive') || 
               description.includes('all inclusive') || 
               name.includes('all inclusive');
      }
      if (detectedFacilities.swimmingPool) {
        return facilities.includes('zwembad') || 
               facilities.includes('pool') || 
               description.includes('zwembad') ||
               description.includes('pool');
      }
      return true;
    });
    
    console.log(`✅ ${facilitiesCheck.length}/${data.length} results match facility requirements`);
  }
  
  // Final hierarchy verification
  let filteredData = data;
  
  if (detectedLocation.type === 'city') {
    const expectedCity = detectedLocation.info.city;
    const expectedRegion = detectedLocation.info.region;
    const expectedCountry = detectedLocation.info.country;
    
    console.log('🎯 Expected hierarchy:', { city: expectedCity, region: expectedRegion, country: expectedCountry });
    
    const correctResults = data.filter(r => 
      r.country === expectedCountry && 
      r.region === expectedRegion &&
      r.city?.toLowerCase().includes(expectedCity.toLowerCase())
    );
    
    if (correctResults.length !== data.length) {
      console.error('❌❌❌ FINAL HIERARCHY ERROR: Some results are outside the specified city!');
      console.log(`🚨 Filtering to ${correctResults.length} correct city results`);
      filteredData = correctResults;
    } else {
      console.log('✅✅✅ All results are from the correct city');
    }
  }
  
  // Final price verification
  if (priceConstraints) {
    console.log('💰 === FINAL PRICE VERIFICATION ===');
    
    if (priceConstraints.maxPrice) {
      const correctPriceResults = filteredData.filter(r => !r.price || r.price <= priceConstraints.maxPrice);
      if (correctPriceResults.length !== filteredData.length) {
        console.log(`🚨 Filtering to ${correctPriceResults.length} results within maxPrice €${priceConstraints.maxPrice}`);
        filteredData = correctPriceResults;
      }
    }
    
    if (priceConstraints.minPrice) {
      const correctPriceResults = filteredData.filter(r => r.price && r.price >= priceConstraints.minPrice);
      if (correctPriceResults.length !== filteredData.length) {
        console.log(`🚨 Filtering to ${correctPriceResults.length} results above minPrice €${priceConstraints.minPrice}`);
        filteredData = correctPriceResults;
      }
    }
  }
  
  // Log sample results
  console.log('📝 Sample results:');
  filteredData.slice(0, 5).forEach((v, i) => {
    console.log(`  ${i + 1}. "${v.name}" - ${v.city || 'No city'}, ${v.region || 'No region'}, ${v.country} - €${v.price || 'N/A'}`);
    if (detectedFacilities) {
      console.log(`     Facilities: ${v.facilities || 'N/A'}`);
    }
  });
  
  return validateVacationData(filteredData);
};
